import React, { useState, useEffect, useContext } from "react"
import Loader from "../Components/Loader"
import { Row, Col, Card } from 'react-bootstrap'

import { Cardstructure, post, sendTrack } from "../Generals"
import dateformat from 'dateformat'
import GeneralContext from "../utils/generalContext";
import noimg from "../no-img.jpg";

export const resolveTemaImageUrl = (img, fallback) => {
    if (!img) return fallback;
    img = img.trim();
    if (/^https?:\/\//i.test(img)) {
        return img.replace(/([^:])\/\/+/g, '$1/');
    }
    var clean = img.replace(/\/+/g, '/').replace(/^\/+/, '');
    if (/^img\//i.test(clean) || /^general\//i.test(clean)) {
        if (/^general\//i.test(clean)) clean = 'img/' + clean;
        return 'https://cursos.birmingham-institute.com/' + clean;
    }
    if (/^images\//i.test(clean)) {
        return 'https://www.birmingham-institute.com/' + clean;
    }
    return 'https://www.birmingham-institute.com/images/' + clean;
};

const PwaInstallPrompt = () => {
    const [dismissed, setDismissed] = useState(
        localStorage.getItem('pwaPromptDismissed') === 'true'
    );
    const [notifPermission, setNotifPermission] = useState(
        'Notification' in window ? Notification.permission : 'default'
    );

    const ua = navigator.userAgent;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;

    const [activeTab, setActiveTab] = useState(
        (/iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) ? 'ios' : 'android'
    );

    if (dismissed || !isMobile || isStandalone) {
        return null;
    }

    const handleDismiss = () => {
        localStorage.setItem('pwaPromptDismissed', 'true');
        setDismissed(true);
    };

    const handleRequestNotifications = async () => {
        if ('Notification' in window) {
            const res = await Notification.requestPermission();
            setNotifPermission(res);
            if (res === 'granted') {
                alert("¡Notificaciones activadas con éxito!");
            }
        } else {
            alert("Las notificaciones no son compatibles con este navegador/dispositivo.");
        }
    };

    return (
        <div className="card shadow-sm border-warning mb-4 bg-light text-left">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                    <h5 className="card-title text-warning m-0 d-flex align-items-center">
                        <i className="fas fa-mobile-alt me-2"></i> Instala la App en tu celular
                    </h5>
                    <button 
                        type="button" 
                        className="btn-close" 
                        aria-label="Close" 
                        onClick={handleDismiss}
                        style={{ border: 'none', background: 'transparent', fontSize: '1.2rem', lineHeight: 1 }}
                    >
                        &times;
                    </button>
                </div>
                
                <p className="card-text small text-muted mt-2">
                    Accede a tus clases, clubes de conversación y tutorías directamente desde tu pantalla de inicio como una aplicación nativa.
                </p>

                <ul className="nav nav-pills nav-fill mb-3" style={{ fontSize: '0.85rem' }}>
                    <li className="nav-item">
                        <button 
                            className={`nav-link py-1 ${activeTab === 'ios' ? 'active bg-warning text-dark' : 'text-dark'}`}
                            onClick={() => setActiveTab('ios')}
                        >
                            <i className="fab fa-apple me-1"></i> iPhone / iPad (iOS)
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link py-1 ${activeTab === 'android' ? 'active bg-warning text-dark' : 'text-dark'}`}
                            onClick={() => setActiveTab('android')}
                        >
                            <i className="fab fa-android me-1"></i> Android
                        </button>
                    </li>
                </ul>

                <div className="tab-content" style={{ fontSize: '0.9rem' }}>
                    {activeTab === 'ios' ? (
                        <div className="ps-2">
                            <div className="mb-2">
                                <strong>1.</strong> Abre esta página en <strong>Safari</strong>.
                            </div>
                            <div className="mb-2">
                                <strong>2.</strong> Presiona el botón de <strong>Compartir</strong> <i className="fas fa-share-square text-primary"></i> (el cuadro con una flecha hacia arriba) en la barra de navegación.
                            </div>
                            <div className="mb-2">
                                <strong>3.</strong> Desliza hacia abajo y presiona <strong>"Agregar a inicio"</strong> (o <strong>"Add to Home Screen"</strong>).
                            </div>
                        </div>
                    ) : (
                        <div className="ps-2">
                            <div className="mb-2">
                                <strong>1.</strong> Abre esta página en <strong>Google Chrome</strong>.
                            </div>
                            <div className="mb-2">
                                <strong>2.</strong> Presiona el menú de <strong>opciones</strong> <i className="fas fa-ellipsis-v text-muted"></i> (tres puntos verticales) arriba a la derecha.
                            </div>
                            <div className="mb-2">
                                <strong>3.</strong> Selecciona <strong>"Instalar aplicación"</strong> o <strong>"Agregar a la pantalla principal"</strong>.
                            </div>
                        </div>
                    )}
                </div>

                <hr className="my-2" />

                <div className="d-flex align-items-center justify-content-between mt-2 flex-wrap gap-2">
                    <span className="small text-muted">
                        <i className="fas fa-bell me-1"></i> Notificaciones: {notifPermission === 'granted' ? 'Activadas' : 'Desactivadas'}
                    </span>
                    {notifPermission !== 'granted' && (
                        <button 
                            className="btn btn-sm btn-outline-primary"
                            onClick={handleRequestNotifications}
                        >
                            Activar notificaciones
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export const Dashboard = () => {
    const { user, global } = useContext(GeneralContext)
    const [dashboard, setDashboard] = useState(false)

    const loadDashboard = () => {
        const userid = user.user.user.id_alumno
        post(
            global.domain + "v3-api/v3/dashboard.json",
            { userid },
            setDashboard
        )
        sendTrack(userid, '/escritorio', window.location.hostname, global);
    }

    useEffect(() => {
        loadDashboard()
    }, [])

    return <div> {!dashboard ? <Loader /> :
        <div className="container-fluid pt-3">
            <PwaInstallPrompt />
            <Row>
            <Col>
                <Cardstructure>
                    <Row>
                        <Col>
                            <h6 className="card-title">Consultas hechas</h6>
                            <div className="d-flex align-items-center justify-content-between mg-b-10">
                                <h1 className="card-value">{dashboard.sessionused}</h1>
                                <a className="btn btn-success"
                                    href={"/historial-de-consultas"}
                                >Ver historial</a>
                            </div>
                        </Col>
                        <Col>
                            <h6 className="card-title">Consultas disponibles</h6>
                            <div className="d-flex align-items-center justify-content-between mg-b-10">
                                <h1 className="card-value">{dashboard.sesionesDisponibles}</h1>
                                <a className="btn btn-success"
                                    href={"/escoger-consulta"}
                                >Haz una consulta</a>
                            </div>
                        </Col>
                    </Row>
                </Cardstructure>
                <Row>
                    {dashboard.cursos.map(item => {
                        let expirationdate = Date.parse(item.expirate_date)
                        let now = new Date()
                        let today = Date.parse(dateformat(now, "isoDateTime"))
                        let status = ""
                        if (expirationdate < today && item.completed === 0) {
                            status = <span className='badge badge-danger mb-3'>Expirado</span>
                        } else if (expirationdate > today && item.completed === 0) {
                            status = <span className='badge badge-info mb-3'>Activo</span>
                        } else if (item.completed === 1) {
                            status = <span className='badge badge-success mb-3'>Completado</span>
                        }
                        let percent = item.percentdone
                        return <Col key={'dashkey' + item.id} sm={12} md={6} className={'pt-4'}>
                            <Cardstructure img={global.domain + item.cursos_curso.img} key={'cardcursos' + item.id}>
                                <Card.Title>{item.cursos_curso.nombre}</Card.Title>
                                <Card.Text>{item.cursos_curso.descriptiontranslated}</Card.Text>
                                {status}
                                <div className="progress mb-3" style={{ height: "10px" }}>
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: percent, height: '10px' }} aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                {expirationdate < today && item.completed === 0 ?
                                    <a href={"/extender/" + item.id}
                                        className="btn btn-outline-warning text-warning btn-block">Ampliar contrato</a>
                                    : <div> {item.stage.notstarted === true ? <div>
                                        <a className='btn btn-outline-info text-info' href={`/tracking/${item.cursos_curso.id}`}>Comenzar ahora!</a>
                                    </div> : <div>
                                        <h6>{item.stage.details.cursositem.titulo} <small>{item.stage.details.cursositem.cursosmodulos.nombre}</small></h6>
                                        {item.stage.details.cursositem.descripcion !== "" && item.stage.details.cursositem.descripcion !== null ? <p>{item.stage.details.cursositem.descripcion}...</p> : null}
                                        <a className='btn btn-outline-info text-info' href={`/tracking/${item.cursos_curso.id}`}>Continuar</a>
                                    </div>}</div>
                                }
                            </Cardstructure>
                        </Col>
                    })}
                </Row>
            </Col>
            <Col>
                <div className="card card-hover card-customer-score ">
                    <div className="card-header bg-transparent">
                        <h6 className="card-title m-0">Clubes de Conversación <span className="badge badge-primary ">Conteo de clubs: {dashboard?.clubconversacion?.conteo || 0}</span></h6>
                        <div>
                            {user?.user?.user?.cursos_zonas_horaria?.nombre} <a className="text-primary" href={'/modificar-perfil'}>Cambiar?</a>
                        </div>
                    </div>
                    <div className="card-body pd-t-10">
                        <div className="alert small alert-warning">
                            Los clubes de conversación se abrirán 5 minutos antes del tiempo programado y se cerrarán 10 minutos después de comenzado.<br />
                            Los clubes pueden cambiar sin previo aviso.
                        </div>
                        {dashboard?.clubconversacion ? <>
                            {dashboard.clubconversacion.actives?.length > 0 ? <div>
                                <p className="content-label mt-3 mg-b-5 tx-secondary">Club activo </p>
                            </div> : null}
                            {dashboard.clubconversacion.actives?.map((clubes, index) => {
                                let rawImg = clubes.cursos_grupos_conversaciones_tema?.img ||
                                             clubes.cursos_grupos_conversaciones_tema?.imagen ||
                                             clubes.cursos_grupos_conversaciones_categoria?.img ||
                                             clubes.cursos_curso?.img ||
                                             clubes.img ||
                                             clubes.imagen;
                                let imgbg = resolveTemaImageUrl(rawImg, noimg);
                                let started = clubes.startedplus10 ? dateformat(clubes.startedplus10, 'dd mmm h:MM TT') : ''
                                let date = clubes.date ? dateformat(clubes.date, 'dd mmm yyyy') : ''
                                let hour = clubes.hour || ''

                                return <div key={'clubesactives' + clubes.id + index}>
                                    <div className="card card-hover card-profile-one">
                                        <div className="row no-gutters">
                                            <div className="col-md-3">
                                                <div className="relative"
                                                    style={{ backgroundSize: 'cover', backgroundImage: 'url(' + imgbg + ')', overflow: 'hidden', height: '100%' }}>
                                                </div>
                                            </div>
                                            <div className="col-md-9">
                                                <div className="card-body">
                                                    <div className="media">
                                                        <div className="">
                                                            <h5 className="card-title">
                                                                <a href={`/detalle-club/${clubes.id}`}>
                                                                    {clubes.cursos_grupos_conversaciones_tema?.nombre ? (
                                                                        <>
                                                                            {clubes.cursos_grupos_conversaciones_tema.nombre} - <small
                                                                                className="text-muted">{clubes.nombre}</small>
                                                                        </>
                                                                    ) : (
                                                                        clubes.nombre
                                                                    )}
                                                                </a>
                                                            </h5>
                                                            {clubes.started !== null && clubes.started !== undefined ? <div>
                                                                <span className="badge-success badge">Ya comenzó pero estas a tiempo de unirte!</span>
                                                                <br />
                                                                <span className="badge-light badge">Hazlo antes de {started}</span>
                                                            </div> : null}

                                                            <p className="card-desc">{clubes.cursos_grupos_conversaciones_tema?.descriptiontranslated || ''}</p>

                                                            <div className="media-footer">
                                                                <div>
                                                                    <h6>{clubes.countmembersactive}/{clubes.limite}</h6>
                                                                    <label>Unidos</label>
                                                                </div>
                                                                <div>
                                                                    <h6>{date} {hour}</h6>
                                                                    <label>Hora Programada</label>
                                                                </div>
                                                                <div><a href={`/detalle-club/${clubes.id}`} className="btn btn-sm btn-info">Entrar
                                                                    al club</a></div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </> : null}

                        {dashboard.clubconversacion?.comming?.length > 0 ? <div>
                            <p className="content-label mt-3 mg-b-5 tx-secondary">Próximos clubes </p>
                        </div> : null}
                        {dashboard.clubconversacion?.comming?.map((clubes, index) => {
                            let rawImg = clubes.cursos_grupos_conversaciones_tema?.img ||
                                         clubes.cursos_grupos_conversaciones_tema?.imagen ||
                                         clubes.cursos_grupos_conversaciones_categoria?.img ||
                                         clubes.cursos_curso?.img ||
                                         clubes.img ||
                                         clubes.imagen;
                            let imgbg = resolveTemaImageUrl(rawImg, noimg);
                            let date = clubes.date ? dateformat(clubes.date, 'dd mmm yyyy') : ''
                            let hour = clubes.hour || ''
                            return <div className={'d-flex align-items-center justify-content-between border-bottom py-2'} key={'clubescomming' + clubes.id + index}>
                                <span className="bgimgh float-left mr-2 d-inline-block mb-3" style={{
                                    backgroundImage: 'url(' + imgbg + ')',
                                    height: '60px',
                                    width: '75px'
                                }}></span>
                                <div style={{ width: '60%' }}>
                                    <a className="link text-left float-left p-0 d-inline-block"
                                        href={`/detalle-club/${clubes.id}`}>
                                        {clubes.cursos_grupos_conversaciones_tema?.nombre || clubes.nombre} {clubes.cursos_grupos_conversaciones_categoria?.nombre ? `- ${clubes.cursos_grupos_conversaciones_categoria.nombre}` : ''}
                                    </a>
                                    <br />
                                    <small>Impartido por {clubes.cursos_profesore?.nombre || 'Profesor'} {clubes.edad !== null && clubes.edad !== "" && clubes.edad !== undefined ? <span>{clubes.edad}</span> : null}</small>
                                    {clubes.cursos_grupos_conversaciones_tema?.cursos_grupos_conversaciones_temas_recursos?.length > 0 ? <>
                                        <br /><span className="badge badge-primary">
                                            <a
                                                className="link text-white text-left float-left p-0 d-inline-block"
                                                href={`/detalle-club/${clubes.id}`}>
                                                <i className="fas fa-info-circle"></i> Tiene recursos para ver previo al club. Click para ver.
                                            </a>
                                        </span></> : null}
                                </div>
                                <div className={'px-2 text-center'}>
                                    {date}
                                </div>
                                <div className={'px-2 text-center'}>
                                    {hour}
                                </div>

                            </div>
                        })}
                    </div>
                </div>
            </Col>
        </Row>
        </div>
    }
    </div>
}

